import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getProStock } from '../../../../Store/prosafe/proStock/getProStock';
import Header from '../../Include/Header';
import Sidebar from '../../Include/Sidebar';
import Footer from '../../Include/Footer';
import Loader from '../../Include/Loader';
import { Pagination } from '../../Table';
import PageHeader from '../../Components/PageHeader/PageHeader';
import useDebounce from '../../../../hooks/useDebounce';
import { getAdminItem } from '../../../../Store/Store/Item/AdminItem';
import { getProject } from '../../../../Store/Store/Project/Project';
import { getCategory } from '../../../../Store/Store/StoreMaster/Category/Category';
import { V_URL } from '../../../../BaseUrl';
import axios from 'axios';
import toast from 'react-hot-toast';
import { getStockValue } from '../../../../Store/prosafe/stockValue/getStockValue';


const StockWithValueList = () => {

    const dispatch = useDispatch();
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setlimit] = useState(10);
    const [search, setSearch] = useState("");

    const [filter, setFilter] = useState({
        startDate: null,
        endDate: null,
        item: null,
        category: null,
        project: null,
        issue_project: null,
    });

    const debouncedSearch = useDebounce(search, 500);

    useEffect(() => {
        fetchData();
    }, [debouncedSearch, filter, currentPage, limit]);

    useEffect(() => {
        dispatch(getAdminItem({ is_main: true }));
        dispatch(getProject());
        dispatch(getCategory());
    }, [dispatch]);

    const fetchData = () => {
        const payload = {
            firm_id: localStorage.getItem('PAY_USER_FIRM_ID'),
            year_id: localStorage.getItem('PAY_USER_YEAR_ID'),
            search: debouncedSearch,
            start_date: filter.startDate,
            end_date: filter.endDate,
            item_id: filter.item,
            item_category_id: filter.category,
            project_id: filter.project,
            issue_project_id: filter.issue_project,
            page: currentPage,
            limit: limit
        }

        dispatch(getStockValue(payload))
    };

    const handleFilterChange = (newFilter) => {
        setFilter(newFilter);
        setCurrentPage(1);
    };

    const entity = useSelector((state) => state.getStockValue?.user?.data);
    const isLoading = useSelector((state) => state?.getStockValue?.loading);
    const itemData = useSelector((state) => state?.getAdminItem?.user?.data);
    const projectData = useSelector((state) => state?.getProject?.user?.data);
    const categoryData = useSelector((state) => state?.getCategory?.user?.data);

    const commentsData = entity?.data || [];
    const summary = entity?.summary || {};

    useEffect(() => {
        if (entity?.pagination?.total) {
            setTotalItems(entity?.pagination?.total);
        }
    }, [entity?.pagination?.total]);

    const handleRefresh = () => {
        setFilter({
            startDate: null,
            endDate: null,
            item: null,
            category: null,
            project: null,
        });
    }

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }

    const filterConfig = [
        {
            key: "item",
            label: "Item",
            type: "dropdown",
            value: filter.item,
            placeholder: "Select Item",
            searchable: true,
            options:
                itemData?.map((item) => ({ label: item.name, value: item._id })) || [],
        },
        {
            key: "category",
            label: "Item Category",
            type: "dropdown",
            value: filter.category,
            placeholder: "Select Item Category",
            searchable: true,
            options:
                categoryData?.map((category) => ({
                    label: category.name,
                    value: category._id,
                })) || [],
        },
        {
            key: "project",
            label: "Project",
            type: "dropdown",
            value: filter.project,
            placeholder: "Select Project",
            searchable: true,
            options:
                projectData?.map((project) => ({
                    label: `${project.name} (${project.project_no})`,
                    value: project._id,
                })) || [],
        },
        {
            key: "issue_project",
            label: "Issue Project",
            type: "dropdown",
            value: filter.issue_project,
            placeholder: "Select Issue Project",
            searchable: true,
            options:
                projectData?.map((project) => ({
                    label: `${project.name} (${project.project_no})`,
                    value: project._id,
                })) || [],
        },
        {
            key: "startDate",
            label: "Start Date",
            type: "date",
            value: filter.startDate,
            placeholder: "Select Start Date",
        },
        {
            key: "endDate",
            label: "End Date",
            type: "date",
            value: filter.endDate,
            placeholder: "Select End Date",
        },
    ];

    const handleDownloadExcel = async () => {
        try {
            const payload = {
                search,
                start_date: filter.startDate,
                end_date: filter.endDate,
                item_id: filter.item,
                item_category_id: filter.category,
                project_id: filter.project,
                issue_project_id: filter.issue_project,
                firm_id: localStorage.getItem("PAY_USER_FIRM_ID"),
                year_id: localStorage.getItem("PAY_USER_YEAR_ID"),
            };

            const res = await axios.post(
                `${V_URL}/prosafe/pro-ms-stock-value-xlsx-download`,
                payload,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
                    },
                }
            );

            if (res?.data) {
                window.open(res?.data?.data?.url);
                toast.success(res?.data?.message || "Excel downloaded successfully");
            } else {
                toast.error("Failed to download");
            }
        } catch (err) {
            console.log(err);
            toast.error(err?.response?.data?.message || "Download failed");
        }
    };

    return (
        <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
            <Header handleOpen={handleOpen} />
            <Sidebar />

            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-sm-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/main-store/user/dashboard">Dashboard </Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <i className="feather-chevron-right"></i>
                                    </li>
                                    <li className="breadcrumb-item active">Stock</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card card-table show-entire">
                                <div className="card-body">

                                    <PageHeader
                                        title="Stock"
                                        onSearch={(value) => {
                                            setSearch(value);
                                            setCurrentPage(1);
                                        }}
                                        onRefresh={handleRefresh}
                                        filter={filter}
                                        onFilterChange={handleFilterChange}
                                        limit={limit}
                                        onLimitChange={(val) => setlimit(val)}
                                        filterConfig={filterConfig}
                                        onDownload={handleDownloadExcel}
                                    />
                                    {!isLoading ? (
                                        <div className="table-responsive">
                                            <table className="table border-0 custom-table comman-table  mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Sr.</th>
                                                        <th>Item Name</th>
                                                        <th>Unit</th>
                                                        <th>Category</th>
                                                        <th style={{ textAlign: "right" }}>Total In</th>
                                                        <th style={{ textAlign: "right" }}>Total In Amount(₹)</th>
                                                        <th style={{ textAlign: "right" }}>Total Out</th>
                                                        <th style={{ textAlign: "right" }}>Balance</th>
                                                        {/* <th>Stock Value</th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {commentsData?.map((elem, i) => (
                                                        <tr key={elem?.item_id || i}>
                                                            <td>{(currentPage - 1) * limit + i + 1}</td>
                                                            <td>{elem?.item_name || '-'}</td>
                                                            <td>{elem?.unit || '-'}</td>
                                                            <td>{elem?.category || '-'}</td>
                                                            <td style={{ textAlign: "right" }}>{elem?.total_in || 0}</td>
                                                            <td style={{ textAlign: "right" }}>{(elem?.total_in_amount || 0).toFixed(2)}</td>
                                                            <td style={{ textAlign: "right" }}>{elem?.total_out || 0}</td>
                                                            <td style={{ color: elem?.balance < 0 ? "red" : "inherit", textAlign: "right" }}>
                                                                {elem?.balance || 0}
                                                            </td>
                                                            {/* <td>{elem?.stock_value || 0}</td> */}
                                                        </tr>
                                                    ))}
                                                    {commentsData?.length === 0 ? (
                                                        <tr>
                                                            <td colSpan="999">
                                                                <div className="no-table-data">
                                                                    No Data Found!
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ) : null}
                                                </tbody>
                                                {commentsData?.length > 0 && (
                                                    <tfoot className="table-footer">
                                                        <tr>
                                                            <td></td>
                                                            <td>Total</td>
                                                            <td></td>
                                                            <td></td>
                                                            <td style={{ textAlign: "right" }}>{summary?.total_in || 0}</td>
                                                            <td style={{ textAlign: "right" }}>{(summary?.total_in_amount || 0).toFixed(2)}</td>
                                                            <td style={{ textAlign: "right" }}>{summary?.total_out || 0}</td>
                                                            <td style={{ color: summary?.total_balance_qty < 0 ? "red" : "inherit", textAlign: "right" }}>
                                                                {summary?.total_balance_qty || 0}
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                )}
                                            </table>
                                        </div>
                                    ) : <Loader />}

                                    <div className="row align-center mt-3 mb-2">
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                                            <div className="dataTables_info" id="DataTables_Table_0_info" role="status"
                                                aria-live="polite">Showing {Math.min(limit, totalItems)} from {totalItems} data</div>
                                        </div>
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                                            <div className="dataTables_paginate paging_simple_numbers"
                                                id="DataTables_Table_0_paginate">
                                                <Pagination
                                                    total={totalItems}
                                                    itemsPerPage={limit}
                                                    currentPage={currentPage}
                                                    onPageChange={(page) => setCurrentPage(page)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <Footer />
            </div>
        </div>
    )
}

export default StockWithValueList